import { AppUtils } from "../../common/utility/appUtil";

export class DraftGridColumnDefs {

  draftsGridDefs() {
    let objAppUtils = new AppUtils();

    return [
      {
        "headerName": "Urgent",
        "field": "urgentFlag",
        hide: false,
        suppressMenu: true,
        resizable: true,
        suppressMovable: true,
        cellRenderer: ""

      },
      {
        "headerName": "Attachment",
        "field": "attchFlag",
        hide: false,
        suppressMenu: true,
        resizable: true,
        suppressMovable: true,
        cellRenderer: ""

      },
      {
        "headerName": "ID",
        "field": "_id",
        hide: false,
        suppressMenu: true,
        resizable: true,
        suppressMovable: true,
        cellRenderer: ""

      },
      {
        "headerName": "Subject",
        "field": "subject",
        //"width": 100,
        // "height": 50,
        suppressMenu: true,
        resizable: true,
        suppressMovable: true,
        hide: false,
        cellRenderer: "",


      },
      {
        "headerName": "Created Date",
        "field": "crtDate.$date",
        hide: false,
        suppressMenu: true,
        resizable: true,
        suppressMovable: true,
        cellRenderer: (data) => {
          return objAppUtils.convertDate(data.value)
        },
        tooltipValueGetter: (data) => {
          return objAppUtils.convertDate(data.value)
        }

      },
      {
        "headerName": "Modified Date",
        "field": "modDate.$date",
        hide: false,
        suppressMenu: true,
        resizable: true,
        suppressMovable: true,
        cellRenderer: (data) => {
          return objAppUtils.convertDate(data.value)
        },
        tooltipValueGetter: (data) => {
          return objAppUtils.convertDate(data.value)
        }

      }
    ]
  }
}